import React, { useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { Navbar } from 'react-bootstrap';
import AuthContext from 'contexts/authContext';
import AppContext from 'contexts/appContext';
import AppsMenu from 'components/app/menu/appsMenu';
import AccountMenu from 'components/app/menu/accountMenu';
import './appHeader.css';

function AppHeader(props) {
  const { authState } = useContext(AuthContext);
  const { appState } = useContext(AppContext);

  const [appsMenuOpen, setAppsMenuOpen] = useState(false);
  const [accountMenuOpen, setAccountMenuOpen] = useState(false);

  const hideMenus = () => {
    setAppsMenuOpen(false);
    setAccountMenuOpen(false);
  };

  const toggleAppsMenu = () => {
    setAccountMenuOpen(false);
    setAppsMenuOpen(!appsMenuOpen);
  };

  const toggleAccountMenu = () => {
    setAppsMenuOpen(false);
    setAccountMenuOpen(!accountMenuOpen);
  };

  const renderBreadcrumb = () => {
    if (appState.breadcrumb && appState.breadcrumb.length > 0) {
      return (
        <ol className='breadcrumb'>
          {
            appState.breadcrumb.map((item, index) => {
              if (item.href === '/' && authState.isPortal) {
                return null;
              }
              else if (item.selected) {
                return (
                  <li className='breadcrumb-item active' key={index}>
                    <span>{item.name}</span>
                  </li>
                );
              }
              else if (item.href) {
                return (
                  <li className='breadcrumb-item' key={index}>
                    <a href={item.href}>{item.name}</a>
                  </li>
                );
              }
              else {
                return (
                  <li className='breadcrumb-item' key={index}>
                    <span>{item.name}</span>
                  </li>
                );
              }
            })
          }
        </ol>
      );
    }
    return null;
  };

  return (
    <>
      <Navbar className='nav-main' expand='lg' bg='app'>
        <div className='d-flex justify-content-between align-items-center w-100'>
          <div className='nav-main-header-left-icon'>
            {/*<BackButton show={appState.isBackButtonVisible} onClick={() => props.history.goBack()} />*/}
          </div>
          <div className='nav-main-header-text flex-grow-1'>
            <div className='nav-main-page-title'>{appState.pageTitle}</div>
            <div className='nav-main-breadcrumb'>
              {renderBreadcrumb()}
            </div>
          </div>
          <div className='nav-main-header-right-icon'>
            <AccountMenuButton show={!authState.isPortal} active={accountMenuOpen} onClick={toggleAccountMenu} />
            <AppsMenuButton show={true} active={appsMenuOpen} onClick={toggleAppsMenu} />
          </div>
        </div>
      </Navbar>
      <AppsMenu open={appsMenuOpen} onClose={hideMenus} />
      <AccountMenu open={accountMenuOpen} onClose={hideMenus} />
    </>
  );
}

export default withRouter(AppHeader);

function AppsMenuButton(props) {
  if (!props.show)
    return null;

  return (
    <div className={'app-header-button' + (props.active ? ' active' : '')} onClick={props.onClick}>
      <i className='icons8-circled-menu' /> <span className='app-header-button-text'>Apps</span>
    </div>
  );
}

function AccountMenuButton(props) {
  if (!props.show)
    return null;

  return (
    <div className={'app-header-button' + (props.active ? ' active' : '')} onClick={props.onClick}>
      <i className='icons8-user' /> <span className='app-header-button-text'>Account</span>
    </div>
  );
}

/*function BackButton(props) {
  if (!props.show)
    return null;

  return (
    <div className='app-back-button' onClick={props.onClick}>
      <i className='icons8-chevron-left' />
    </div>
  );
}*/